export const environment = {
    production: false,
    apiEndpoint: 'https://dev-api.eduscript.ai/api/',
    orgName: 'dev',
};
